import { NudgesAPI } from "@/lib/api"
import { SET_NUDGES } from "@/store/mutationTypes"

const state = {
  all: []
}

// getters
const getters = {
  getNudgesByNudgeable: (state, getters, rootState, rootGetters) => (
    nudgeableType,
    nudgeableId
  ) => {
    return state.all.filter(el => {
      return (
        el.nudgeable_id == nudgeableId && el.nudgeable_type == nudgeableType
      )
    })
  }
}

// actions
const actions = {
  async loadNudgesByMentee({ commit }, menteeId) {
    const data = await NudgesAPI.list(menteeId)
    commit(SET_NUDGES, data)
  },
  async nudge({}, { nudgeableType, nudgeableId, menteeId, mentorId, text }) {
    await NudgesAPI.nudge(nudgeableType, nudgeableId, menteeId, mentorId, text)
  }
}

const mutations = {
  [SET_NUDGES](state, nudges) {
    state.all = nudges
  },
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
